exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel .panel-heading {\n  margin-left: -15px;\n  margin-right: -15px\n}\n\n.form-group.required .control-label:after {\n  content:\"*\";\n  color:red;\n  margin-left: 3px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/questionnaire-edit/questionnaire-edit.component.css
// module id = ../../../../../src/app/questionnaire-edit/questionnaire-edit.component.css
// module chunks = main